export const isInvalidTextInput = (input: string): boolean => {
    const whiteSpaceRegex = new RegExp("^\\s*$");
    return !input || whiteSpaceRegex.test(input);
};
